import { formatInTimeZone } from 'date-fns-tz';

export class ResolutionTools {
    public static getMinutesFromDate(date: Date): number {
        let strHour = formatInTimeZone(date, 'Europe/Berlin', 'HH:mm');
        let strDate = formatInTimeZone(date, 'Europe/Berlin', 'yyyy-MM-dd');
        let minutes = this.getMinutesFromHourString(strHour);
        let days = Math.floor(new Date(strDate).getTime() / 1000 / 60 / 60 / 24);
        return minutes + days * 24 * 60;
    }

    public static getMinutesFromHourString(hourString: string): number {
        let parts = hourString.split(':');
        if (parts.length != 2) {
            return 0;
        }
        let hours = parseInt(parts[0]);
        let minutes = parseInt(parts[1]);
        return hours * 60 + minutes;
    }
}
